import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import { ScrollGuard } from 'src/app/shared/utils/scroll-guard';
import { BlukitMobileSalesPrivacyPolicyComponent } from './blukit_mobile_sales_privacy_policy';

const routes: Routes = [
  { path: '', component: BlukitMobileSalesPrivacyPolicyComponent, canActivate: [ScrollGuard]  },
  { path: 'blukit_mobile_sales_privacy_policy', component: BlukitMobileSalesPrivacyPolicyComponent, canActivate: [ScrollGuard]  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlukitMobileSalesPrivacyPolicyRoutingModule { }
